(() => {
  const timers = new WeakMap();
  const layoutObservers = window.__iseebizBannerGridObservers || new WeakMap();
  window.__iseebizBannerGridObservers = layoutObservers;
  function mountLayouts(root = document) {
    root.querySelectorAll('.banner-grid--type-3').forEach((grid) => {
      const update = () => grid.classList.toggle('banner-grid--compact-mobile', grid.getBoundingClientRect().width < 750);
      update();
      if (!layoutObservers.has(grid)) {
        const observer = new ResizeObserver(update);
        observer.observe(grid);
        layoutObservers.set(grid, observer);
      }
    });
  }
  function mount(root = document) {
    mountLayouts(root);
    root.querySelectorAll('[data-countdown]').forEach((el) => {
      if (timers.has(el)) clearInterval(timers.get(el));
      const deadline = Date.parse(el.dataset.deadline || '');
      const mock = el.dataset.mock === 'true' || !Number.isFinite(deadline);
      const mockMs = ((Number(el.dataset.mockDays) || 0) * 86400000) + ((Number(el.dataset.mockHours) || 0) * 3600000);
      const end = mock ? Date.now() + Math.max(mockMs, 3600000) : deadline;
      const values = el.querySelectorAll('[data-countdown-value]');
      const render = () => {
        let left = Math.max(0, end - Date.now());
        const parts = [Math.floor(left / 86400000), Math.floor(left / 3600000) % 24, Math.floor(left / 60000) % 60, Math.floor(left / 1000) % 60];
        values.forEach((node, index) => { node.textContent = String(parts[index] || 0).padStart(2, '0'); });
      };
      render(); timers.set(el, setInterval(render, 1000));
    });
  }
  document.addEventListener('DOMContentLoaded', () => mount());
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:block:select', (event) => mount(event.target.closest('.shopify-section') || document));
})();
